import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const [enable, setEnable] = useState();

  useEffect(() => {
    setEnable(command.data.enable);
  }, [command.data]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Enable">
        <Select name="enable" value={enable} onChange={handleBlur} className={cx('select')}>
          <option value={1}>On</option>
          <option value={0}>Off</option>
        </Select>
      </FieldRow>
    </div>
  );
};

export default Command;
